import React, { Component } from 'react';

class OpChecklist extends Component {

  render() {

    return (
      <React.Fragment>
        {this.props.groups.map((e) => (
          <div className="form-check border-top" key={e.groupe}
            style={{
              color: this.props.properties.find((f) => f.groupe == e.groupe) ? this.props.properties.find((f) => f.groupe == e.groupe).color : "white"
            }}>
            <input className="form-check-input" type="checkbox" value={e.groupe} id="flexCheckDefault" checked={e.active}
              onChange={(e) => this.props.handleToggle(e)}
            />
            <h5 className="form-check-label" htmlFor="flexCheckDefault">
            {this.props.properties.find((f) => f.groupe == e.groupe) ? this.props.properties.find((f) => f.groupe == e.groupe).nom : 'operateur'}
            </h5>

            <div>
              <label className="card-subtitle mb-2 text-muted">
                {this.props.properties.find((f) => f.groupe == e.groupe) ? this.props.properties.find((f) => f.groupe == e.groupe).region : 'region'}
              </label>
            </div>

          </div>

        ))}
      </React.Fragment >
    );
  }
}

export default OpChecklist;